import { useFeedback } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import {
  Button,
  Descriptions,
  Flex,
  Input,
  Popconfirm,
  Space,
  Typography,
} from "antd";
import React from "react";
import { Media } from "../../../../js/parsegenerated";

export default (props: {
  fileData: Media;
  showActions?: boolean;
  onDelete?: (file: Media) => void;
}) => {
  const t = useTranslation();
  const { notification } = useFeedback();
  const [isEditing, setIsEditing] = React.useState(false);
  const [description, setDescription] = React.useState(
    props.fileData.description
  );

  const showEditButton = !isEditing && props.showActions;
  const showEditControls = isEditing && props.showActions;

  function handleEditCancel() {
    setDescription(props.fileData.description);
    setIsEditing(false);
  }

  async function handleEditSubmit() {
    try {
      props.fileData.set("description", description);
      await props.fileData.save();
      setIsEditing(false);
      notification.success({
        message: t("maintenance:global.notifications.save.success"),
      });
    } catch (e) {
      console.error(e);
      notification.error({
        message: t("maintenance:global.messages.save.error"),
      });
    }
  }

  return (
    <Descriptions
      bordered
      layout="horizontal"
      key={props.fileData.id}
      size="small"
      items={[
        {
          key: "description",
          label: t("maintenance:knowledge.admin.table.description.label"),
          children: (
            <Flex justify="space-between" align="center">
              {isEditing && (
                <Input.TextArea
                  value={description}
                  onChange={(e) => setDescription(e.currentTarget.value)}
                />
              )}
              {!isEditing && (
                <Typography.Text>{props.fileData.description}</Typography.Text>
              )}
              <Flex gap="8px" align="center">
                {showEditButton && (
                  <Button onClick={() => setIsEditing(true)}>
                    <Icon icon="fa:edit" />
                  </Button>
                )}
                {showEditControls && (
                  <>
                    <Button onClick={handleEditSubmit}>
                      <Icon icon="fa:check" />
                    </Button>
                    <Button onClick={handleEditCancel}>
                      <Icon icon="fa:times" />
                    </Button>
                  </>
                )}
              </Flex>
            </Flex>
          ),
        },
        {
          key: "name",
          label: t("maintenance:knowledge.admin.table.file.label"),
          children: (
            <Flex justify="space-between" align="center">
              <Typography.Link
                href={props.fileData.media.url()}
                target="_blank"
              >
                <Space size="small">
                  <Icon icon="fa:link" />
                  {props.fileData.media.name().split("_")[1]}
                </Space>
              </Typography.Link>{" "}
              {props.onDelete && (
                <Popconfirm
                  title={t(
                    "maintenance:knowledge.admin.table.actions.file.delete.title"
                  )}
                  onConfirm={() => props.onDelete(props.fileData)}
                >
                  <Button danger>
                    <Icon icon="fa:trash" />
                  </Button>
                </Popconfirm>
              )}
            </Flex>
          ),
        },
      ]}
    />
  );
};
